import { util } from 'echarts';
import { ThemeParser } from '../../../core/theme';
import { defaultGrid, preporcessGrid, parseGrid } from '../../ainvest/component/grid';

const gridOpt = defaultGrid();
const defaultMainGrid = util.merge(
  util.clone(gridOpt[0]),
  {
    left: 0,
    top: 8,
    right: 0,
    // 高度包含了x轴
    height: 212,
    containLabel: true
  },
  true
);
const defaultAttechedGrid = gridOpt[1];

export function gridThemeParse(...args: Parameters<ThemeParser>) {
  const [option] = args;
  preporcessGrid(option);
  parseGrid(option, [defaultMainGrid, defaultAttechedGrid]);
}
